import { graphql } from '../../../graphql/generated';

export const CREATE_ECARD_CONFIG_MUTATION = graphql(`
  mutation CreateEcardConfig($input: EcardConfigInput!) {
    createEcardConfig(input: $input) {
      id
    }
  }
`);
